import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DynamicColumnWidthDirective} from '../dynamic-column-width.directive';
import {CommonTreeComponent} from './common-tree/common-tree.component';
import {
  NzButtonModule,
  NzCheckboxModule,
  NzGridModule,
  NzIconModule,
  NzInputModule, NzMessageService,
  NzModalModule, NzSpinModule, NzTableModule,
  NzToolTipModule,
  NzTreeModule
} from 'ng-zorro-antd';
import {SharedModule} from '../../shared/shared.module';
import {CommonTreeSelectComponent} from './common-tree-select/common-tree-select.component';
import {TableCustomSettingComponent} from './table-custom-setting/table-custom-setting.component';
import {DragDropModule} from '@angular/cdk/drag-drop';
import { HscModalComponent } from './hsc-modal/hsc-modal.component';
import {SafePipe} from '../safe-pipe';
import { FileListComponent } from './file-list/file-list.component';
import { EmblaCarouselComponent } from './embla-carousel/embla-carousel.component';
import { ApprovalInfoComponent } from './approval-info/approval-info.component';
import {
  AccountNoMaskingPipe,
  CertificateAccountMaskingPipe,
  PhoneMaskingPipe,
  TelephoneMaskingPipe
} from '../data-masking-pipe';
import { DataMaskingControllerComponent } from './data-masking-controller/data-masking-controller.component';
import { BarcodeChargeModalComponent } from './barcode-charge-modal/barcode-charge-modal.component';
import { FilePreviewListComponent } from './file-preview-list/file-preview-list.component';
import { NewHscModalComponent } from './new-hsc-modal/new-hsc-modal.component';
import { NewHscModalV1Component } from './new-hsc-modal/new-hsc-modal-v1/new-hsc-modal-v1.component';
import { NewHscModalV2Component } from './new-hsc-modal/new-hsc-modal-v2/new-hsc-modal-v2.component';
import { CropperImgComponent } from './cropper-img/cropper-img.component';
import { NzSelectModule } from '../../components/select';

@NgModule({
  declarations: [
    CommonTreeComponent,
    CommonTreeSelectComponent,
    TableCustomSettingComponent,
    HscModalComponent, SafePipe,
    FileListComponent, EmblaCarouselComponent,
    ApprovalInfoComponent, PhoneMaskingPipe,
    CertificateAccountMaskingPipe,
    TelephoneMaskingPipe,
    DataMaskingControllerComponent,
    AccountNoMaskingPipe,
    BarcodeChargeModalComponent,
    FilePreviewListComponent,
    NewHscModalComponent,
    NewHscModalV1Component,
    NewHscModalV2Component,
    CropperImgComponent,
    DynamicColumnWidthDirective
  ],
  exports: [
    CommonTreeComponent,
    TableCustomSettingComponent,
    HscModalComponent,
    SafePipe,
    FileListComponent,
    EmblaCarouselComponent,
    ApprovalInfoComponent,
    PhoneMaskingPipe,
    CertificateAccountMaskingPipe,
    TelephoneMaskingPipe,
    DataMaskingControllerComponent,
    AccountNoMaskingPipe,
    BarcodeChargeModalComponent,
    FilePreviewListComponent,
    NewHscModalComponent,
    CropperImgComponent,
    DynamicColumnWidthDirective
  ],
  imports: [
    CommonModule,
    NzIconModule,
    NzToolTipModule,
    NzInputModule,
    NzTreeModule,
    SharedModule,
    NzGridModule,
    NzModalModule,
    NzCheckboxModule,
    NzTableModule,
    NzButtonModule,
    NzSpinModule,
    DragDropModule,
    NzSelectModule
  ],
  providers: [
    NzMessageService,
  ]
})
// @ts-ignore
export class ComponentModule {
}
